// angular
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-additional-specification-box',
  standalone: true,
  imports: [NgClass, TranslateModule],
  templateUrl: './additional-specification-box.component.html',
  styleUrl: './additional-specification-box.component.scss',
})
export class AdditionalSpecificationBoxComponent {
  // inputs
  additionalTitle = input<string>('property');
  additionalTitleSuffix = input<string | null>();
  heightMax = input<boolean>(false);
}
